import React, { useContext } from "react";
import PropTypes from "prop-types";
// mui
import Grid from "@mui/material/Grid";
// component
import ButtonMain from "../../../../../../../../../../../common/components/button/ButtonMain";
import Act from "../../../../../../../../../../../store/actions";
import { StoreContext } from "../../../../../../../../../../../store/StoreProvider";
// img
import arrowLeftIcon from "../../../../../../../../../../../../images/ai_image/arrow-left.svg";
import disArrowLeftIcon from "../../../../../../../../../../../../images/ai_image/arrow_left_large.svg";
import PanelItems from "./PanelItems";
import { excelDownloader } from "../../../../../../../../../utils/excelDownloader";
import { aiPageConfig } from "../../../../../textConfig";

const BottomPanel = ({ isFetch, isDataEmpty }) => {
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { tableData } = sna.AI;

  const handleFoundUnfilled = () => {
    const foundUnfilled = tableData.find((dt) => !dt.srcLabel || !dt.dstLabel);
    return foundUnfilled;
  };

  const handleClick = (type) => {
    switch (type) {
      case "downloadList": {
        if (handleFoundUnfilled()) {
          alert("請確認所有必填欄位皆有填寫！");
        } else {
          excelDownloader(
            tableData,
            aiPageConfig.excelHeaderCh,
            aiPageConfig.excelHeaderEn,
            "AI語意分析結果.xlsx"
          );
        }
        break;
      }
      case "generateNetwork": {
        if (handleFoundUnfilled()) {
          alert("請確認所有必填欄位皆有填寫！");
        } else {
          dispatch({
            type: Act.SNA_SET_AI_CURRENT_PAGE,
            payload: "sna",
          });
        }
        break;
      }
      default:
        break;
    }
  };

  return (
    <Grid container>
      <Grid xs item>
        {" "}
        <ButtonMain
          buttonProps={{
            text: "上一步",
            onClick: () => {
              dispatch({
                type: Act.SNA_SET_AI_CURRENT_PAGE,
                payload: "main",
              });
            },
            startIcon: (
              <img
                src={isFetch ? disArrowLeftIcon : arrowLeftIcon}
                alt="arrowLeft"
              />
            ),
            variant: isFetch ? "disabled" : "feedback",
            sx: { borderRadius: "8px", padding: "8px 24px 8px 16px" },
            disabled: isFetch,
          }}
        />
      </Grid>
      <Grid xs item sx={{ textAlign: "end" }}>
        {PanelItems.map((el) => (
          <ButtonMain
            key={el.text}
            buttonProps={{
              text: el.text,
              onClick: () => handleClick(el.type),
              variant:
                isFetch || isDataEmpty || tableData.length === 0
                  ? "disableLinearGradient"
                  : "linearGradient",
              sx: {
                padding: "8px 24px",
                borderRadius: "8px",
                boxShadow: "0 0 16px rgba(59,191,240,0.2)",
                marginLeft: "8px",
              },
              disabled: isFetch || isDataEmpty || tableData.length === 0,
            }}
          />
        ))}
      </Grid>
    </Grid>
  );
};
export default BottomPanel;
BottomPanel.propTypes = {
  isFetch: PropTypes.bool,
  isDataEmpty: PropTypes.bool,
};
BottomPanel.defaultProps = {
  isFetch: PropTypes.bool,
  isDataEmpty: PropTypes.bool,
};
